import { clubService } from '@/services/storageService';
import { ApiClub } from '@/types';

export const fetchClubsForUser = async (
  userId: string | undefined | null,
  _opts?: Record<string, never>,
): Promise<ApiClub[]> => {
  if (!userId) return [];
  try {
    const mine = (await clubService.listMine()) as ApiClub[];
    return Array.isArray(mine) ? mine : [];
  } catch {
    return [];
  }
};
